<div class="back-button-container" [ngStyle]="style" [ngClass]="{'fixed': fixed}">
  <button
    type="button"
    class="back-button"
    mat-icon-button
    (click)="onGoBack()"
  >
    <mat-icon class="hide-gt-xs">arrow_back</mat-icon>
    <mat-icon class="show-gt-xs">{{ stopNavigation ? "close" : "arrow_back" }}</mat-icon>
  </button>
</div>
